import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@ortho-next/auth-core';
import { SseService } from '@ortho-next/sse';
import { firstValueFrom } from 'rxjs';
import { APP_CONFIG, AppConfig, LanguageService, MonitoringService } from './core';


/**
* Root application component.
*/
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [
		RouterOutlet
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
	constructor(
		private readonly sse: SseService,
		private readonly titleService: Title,
		private readonly langSrv: LanguageService,
		private readonly authService: AuthService,
		private readonly monitoringService: MonitoringService,
		@Inject(APP_CONFIG) private readonly config: AppConfig
	) {
		authService.isDoneLoading$.subscribe(() => {
			if (authService.hasValidToken()) {
				sse.connection(config.sseAPI, () => firstValueFrom(authService.getAccessToken()));

				const userName = authService.userName;
				if (userName) {
					monitoringService.setAuthenticatedUserId(userName);
				}
			}
		});

		authService.onLogout$.subscribe(() => monitoringService.clearAuthenticatedUserId());
	}

	ngOnInit(): void {
		this.titleService.setTitle(this.langSrv.labels().APP_MAIN_TITLE);
	}

}
